import React from 'react';
import { ReviewInfoContainer } from '../../../../../containers';

export const ReviewInfo = () => <ReviewInfoContainer />;
